export const semanticColors = {
  pink: "#E03997",
  orange: "#F26202",
  green: "#16AB39",
  teal: "#00B5AD",
};
